import PropTypes from 'prop-types';

export const OptionPropTypes = PropTypes.shape({
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  label: PropTypes.string,
});

export const OptionsPropType = PropTypes.arrayOf(OptionPropTypes).isRequired;

export const ColumnDefinitionPropTypes = PropTypes.oneOfType([
  PropTypes.shape({
    headerName: PropTypes.string,
    field: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    headerName: PropTypes.string,
    valueGetter: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  }),
  PropTypes.shape({
    cellRenderer: PropTypes.node.isRequired,
  }),
]);

export const ColumnDefinitionsPropTypes = PropTypes.arrayOf(ColumnDefinitionPropTypes);
